export const getTelegramWebApp = () => window.Telegram?.WebApp || null;

export const initTelegramWebApp = () => {
    const webApp = getTelegramWebApp();
    if (!webApp) return null;

    webApp.ready?.();
    webApp.expand?.();
    return webApp;
};

export const getSalesChannel = () => {
    if (getTelegramWebApp()?.initData) return 'telegram_mini_app';
    const launchData = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('tgWebAppData');
    if (launchData) return 'telegram_mini_app';
    try {
        const params = JSON.parse(window.sessionStorage.getItem('__telegram__initParams'));
        if (params?.tgWebAppData) return 'telegram_mini_app';
    } catch {
        // Storage can be disabled in private browsers.
    }
    return 'website';
};

export const openPaymentPage = (url) => {
    const webApp = getTelegramWebApp();
    if (getSalesChannel() === 'telegram_mini_app' && typeof webApp?.openLink === 'function') {
        try {
            webApp.openLink(url);
            return;
        } catch {
            // Older Telegram clients can fall back to normal browser navigation.
        }
    }
    window.location.assign(url);
};
